export default "__VITE_ASSET__DoVIEA5x__"